export const version = '1.0.6';
//# sourceMappingURL=version.js.map